<template name="pagination">
  <div class="flex content-center justify-between bg-gray-200 p-2">
    <div>
      <ul class="pagination">
        <li class="pagination-item" v-show="!isInFirstPage">
          <a
            @click.prevent="onClickFirstPage"
            class="pageing border-t border-b border-l hover:opacity-50"
            href="#"
            role="button"
            rel="prev"
          >
            &laquo;
          </a>
        </li>

        <li class="pagination-item">
          <button
            type="button"
            @click="onClickPreviousPage"
            v-show="!isInFirstPage"
            aria-label="Go to previous page"
            class="pageing bg-white hover:opacity-50"
            :class="{ 'cursor-not-allowed': isInFirstPage }"
          >
            Previous
          </button>
        </li>

        <li v-for="page in pages" class="pagination-item" :key="page.name">
          <span
            class="pageing cursor-not-allowed"
            v-if="isPageActive(page.name)"
            >{{ page.name }}</span
          >
          <a
            class="pageing bg-white hover:opacity-50"
            href="#"
            v-else
            @click.prevent="onClickPage(page.name)"
            role="button"
            >{{ page.name }}</a
          >
          <!-- <button
                type="button"
                @click="onClickPage(page.name)"
                :disabled="page.isDisabled"
                :class="{ active: isPageActive(page.name) }" 
            >{{ page.name }}</button> -->
        </li>

        <li class="pagination-item">
          <button
            type="button"
            @click="onClickNextPage"
            :disabled="isInLastPage"
            aria-label="Go to next page"
            class="
              pageing
              bg-white
              opacity-100
              hover:opacity-50
              disabled:opacity-50
            "
            :class="{ 'cursor-not-allowed': isInLastPage }"
          >
            Next
          </button>
        </li>

        <li class="pagination-item">
          <!-- <button
                type="button"
                @click="onClickLastPage"
                :disabled="isInLastPage"
                aria-label="Go to last page"
            >Last</button> -->
          <a
            class="pageing hover:bg-gray-100"
            href="#"
            @click.prevent="onClickLastPage"
            rel="next"
            role="button"
            v-if="hasMorePages"
            >&raquo;</a
          >
        </li>
      </ul>
    </div>

    <div class="flex w-4/12 right flex-none mr-2 justify-center content-center">
   
      <div class="flex float-right" v-if="shouldShowPageSize">
        <Dropdown
          :options="pageSizeDropdown"
          :selected="pageSizeSelected"
          :title="'Showing'"
          v-on:updateOption="updateSelectedPageSize"
          class="border-transparent px-0 bg-white mr-0"
        ></Dropdown>

        <div class="pt-2 bg-white pl-0 pr-4 text-gray-500 text-sm -ml-2 z-50">
          of {{ total }} results
        </div>
      </div>

      <div v-else class="pt-2 w-full text-right">Showing {{ total }} results</div>
    </div>
  </div>
</template>

<script>
const Dropdown = () => import("@/components/Dropdown.vue");

export default {
  name: "pagination",
  components: {
    Dropdown,
  },
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 5,
    },

    totalPages: {
      type: Number,
      required: true,
    },

    total: {
      type: Number,
      required: true,
    },

    currentPage: {
      type: Number,
      required: true,
    },

    pageSize: {
      type: Number,
      required: true,
    },

    hasMorePages: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        let result = this.totalPages - this.maxVisibleButtons + 1;
        return result <= 0 ? 1 : result;
      }

      return this.currentPage - 1;
    },
    endPage() {
      return Math.min(
        this.startPage + this.maxVisibleButtons - 1,
        this.totalPages
      );
    },
    pages() {
      const range = [];

      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage,
        });
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
    pageSizeDropdown() {
      return this.sizeList;
    },
    shouldShowPageSize() {
      return this.pageSizeSelected.value < this.total;
    },
  },
  data() {
    return {
      pageSizeSelected: {},
      sizeList: [],
    };
  },
  created() {
    this.sizeList = [
      { name: "24", value: 24 },
      { name: "48", value: 48 },
      { name: "120", value: 120 },
    ];

    let found = this.sizeList.find((l) => l.value === this.pageSize);
    if (found != undefined) {
      this.pageSizeSelected = found;
    } else {
      this.pageSizeSelected = this.sizeList[0];
    }
  },

  methods: {
    onClickFirstPage() {
      this.sendResult(1);
    },
    onClickPreviousPage() {
      this.sendResult(this.currentPage - 1);
    },
    onClickPage(page) {
      this.sendResult(page);
    },
    onClickNextPage() {
      this.sendResult(this.currentPage + 1);
    },
    onClickLastPage() {
      this.sendResult(this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    },
    updateSelectedPageSize(value) {
      this.pageSizeSelected = value;
      this.sendResult(this.startPage);
    },
    sendResult(page) {
      this.$emit("pagechanged", {
        page: page,
        size: this.pageSizeSelected.value,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}

.active {
  @apply .border-t .border-b .border-l .border-blue-100 .px-3 .py-2 .bg-blue-100 .no-underline .text-blue-500 .text-sm;
}

.pageing {
  @apply rounded-sm border border-blue-100 px-3 py-2 bg-gray-300 no-underline text-gray-600   mx-2;
}
</style>